import { ContentSaveAllIcon } from './ContentSaveAllIcon';

/**
 * author: Austin Andrews
 * id B9BE7889-D858-41A1-AB4E-9C58325261E9
 * name content-save-all
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/content-save-all.svg
 * tags
 */
export const FloppyDiscMultipleIcon = ContentSaveAllIcon;
export default FloppyDiscMultipleIcon